import { GenerateReportBody } from "../../../../../../../components/Modals/GenerateReport";
import { MenuButton } from "../../../../../../../components/ui/MenuButton";

const CreditNoteActions = ({ values: row, invoiceId }) => {
  const creditId = row?.creditId;
  const hasValidCreditId =
    (typeof creditId === "number" || typeof creditId === "string") &&
    Number.isSafeInteger(Number(creditId)) &&
    Number(creditId) > 0;

  if (row?.typeId !== 6 || !hasValidCreditId) {
    return null;
  }

  const reference = row.creditNoteRef?.trim();
  const options = [
    {
      label: reference ? `Credit Note for ${reference}` : "Credit Note",
      modalProps: {
        body: GenerateReportBody,
        type: "Invoice",
        report: "creditNote",
        ids: [invoiceId],
        // creditId identifies the Payment shared by all lines of this note.
        creditNoteId: creditId,
        creditNoteReference: row.creditNoteRef,
        closeOnBackdrop: false,
        hideCloseButton: true,
        scale: "md",
      },
    },
  ];

  return (
    <MenuButton label="Actions" iconOnly alignLeft portal options={options} />
  );
};

export default CreditNoteActions;
